import { oidcUserDefault } from '../domain/oidc-user/oidcUser';

export const useAccessTokenDefault = oidcUserDefault.access_token;
